'use client';
import cn from '@/lib/clsxm';

import Container from '@/components/@base/container';
import Props from '@/components/app/archive/components/products/loading/type';
import RowProductCardLoading from '@/components/app/archive/components/products/row-product-card/loading';
import { VIEW_MODE } from '@/components/app/archive/helpers/hooks/type';
import ProductCardLoading from '@/components/shared/components/cards/product/loading';
import { loadingGenerator } from '@/components/shared/helpers';

import { useViewModeStore } from '@/store/view-mode.store';

export default function Loading({ numberOfCards = 3, className }: Props) {
  const { viewMode } = useViewModeStore();

  return viewMode === VIEW_MODE.LIST ? (
    <Container>
      {loadingGenerator(numberOfCards, () => (
        <Container className='py-2'>
          <RowProductCardLoading />
        </Container>
      ))}
    </Container>
  ) : (
    <Container
      className={cn(
        'mx-4 grid grid-cols-1 gap-4 pb-4 md:mx-0 md:grid-cols-2 lg:grid-cols-3',
        className,
      )}
    >
      {loadingGenerator(numberOfCards, () => (
        <ProductCardLoading />
      ))}
    </Container>
  );
}
